'use strict'

/*
 * Sample of use:
 *
 * ```
 * <div class="form-group mdl-form-group-file">
 *     {{ Form::label('image_file', 'Image') }}
 *     {{ Form::file('image_file', ['placeholder' => 'Image', 'class' => 'form-control', 'data-file' => $goody->image_file]) }}
 * </div>
 */
const $ = window.$ = window.jQuery = require('jquery')

let button = `
    <button type="button" class="btn btn-primary bmd-btn-icon active">
        <i class="fa" aria-hidden="true"></i>
    </button>
`

export default function () {
  $('.mdl-form-group-file').each(function () {
    let $container = $(this)
    let $input = $container.find('input[type=file]')
    let $faker = $('<input type="text" readonly/>')
    let $button = $(button)

    let attributes = [
      ['class', $input.attr('class')],
      ['placeholder', $input.attr('placeholder')],
      ['value', $input.attr('data-file')]
    ]

    attributes.forEach(function (attr) {
      $faker.attr(attr[0], attr[1])
    })

    $button.find('.fa').addClass('fa-' + ($container.attr('data-icon') || 'upload'))
    $input.hide().find('label').hide()
    $container.append($faker).append($button)

    $button.click(function () {
      $input.click()
      $faker.focus()
    })

    $input.change(function () {
      $faker.val(this.files[0].name)
    })
  })
}



// WEBPACK FOOTER //
// ./resources/assets/js/mdl/upload.js